import XeroChangeLogView from "@/components/admin/XeroChangeLogView";
import { XERO_ORG_RULES_LOGS_QUERY_KEY, getXeroOrgRulesLogs } from "@/services/xeroApi";

const FIELD_LABELS: Record<string, string> = {
  entity: "Entity",
  retrieval_date: "Retrieval date",
  retrieval_month: "Retrieval month",
  pre2022_source: "Pre-2022 source",
  default_legacy_office: "Legacy office",
  required_in_cube: "Required in cube",
};

const DATE_FIELDS = ["retrieval_date"] as const;

const SOURCES = ["edit", "bulk_import", "seed"] as const;

export default function XeroOrganisationsLogPage() {
  return (
    <XeroChangeLogView
      title="Organisations change log"
      labelHeading="Organisation"
      fieldLabels={FIELD_LABELS}
      dateFields={DATE_FIELDS}
      sources={SOURCES}
      queryKey={XERO_ORG_RULES_LOGS_QUERY_KEY}
      fetchPage={getXeroOrgRulesLogs}
      backTo="/datacore/xero?tab=organisations"
      backLabel="Back to Organisations"
    />
  );
}
